export default function MissionSection() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Clinical Excellence',
      description: 'Licensed Nurse Practitioners with specialized training in IV therapy and advanced clinical care.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Discretion & Privacy',
      description: 'Private suites and confidential service for every client.',
    },
    {
      icon: 'ri-star-line',
      title: 'Luxury Experience',
      description: 'A spa-like environment that redefines what medical wellness can feel like.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Personalized Care',
      description: 'Customized treatments tailored to your unique wellness goals and health history.',
    },
    {
      icon: 'ri-award-line',
      title: 'Evidence-Based Treatments',
      description: 'Every infusion is formulated using medical-grade ingredients and delivered with careful clinical oversight.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Comfort-Centered Care',
      description: 'Every detail of your experience is thoughtfully designed to keep you at ease from arrival to completion.',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-bone">
      <div className="max-w-7xl mx-auto">

        {/* Mission Header */}
        <div className="text-center mb-16">
          <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-4">Our Purpose</p>
          <h2 className="text-4xl md:text-5xl font-light text-charcoal mb-6 tracking-wide">
            Our Mission
          </h2>
          <div className="w-16 h-px bg-gold mx-auto mb-8"></div>
          <div className="max-w-3xl mx-auto space-y-5 text-greige text-base font-light leading-relaxed">
            <p>
              Our mission is to bring high-quality hydration and wellness therapies into a setting that feels both professional and approachable.
            </p>
            <p>
              We believe preventative wellness, proper hydration, and nutrient optimization play a major role in how people feel and perform in everyday life. Through medically supervised IV therapy, we aim to help our clients recover faster, feel better, and maintain their energy in demanding lifestyles.
            </p>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {values.map((value, index) => (
            <div key={index} className="text-center group">
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-gold/10 group-hover:bg-gold transition-all duration-300">
                <i className={`${value.icon} text-2xl text-gold group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm font-normal text-charcoal mb-3 tracking-widest uppercase">
                {value.title}
              </h3>
              <p className="text-greige text-sm font-light leading-relaxed max-w-xs mx-auto">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* Why IV Hydration Club */}
        <div className="bg-sand rounded-2xl p-12 lg:p-16 text-center">
          <h3 className="text-3xl font-light text-charcoal mb-6 tracking-wide">
            Why IV Hydration Club
          </h3>
          <p className="text-greige text-base font-light leading-relaxed max-w-3xl mx-auto mb-6">
            We are not just a clinic — we are a wellness destination where fast, effective recovery meets the sophistication of a private members' lounge. Every treatment is administered with precision, every space designed for serenity, and every client treated with the utmost care and respect.
          </p>
          <p className="text-gold text-sm font-light tracking-widest uppercase">
            By Appointment Only
          </p>
        </div>

      </div>
    </section>
  );
}
